module.exports = __webpack_public_path__ + "img/noEvents.8845e7f1.svg";